import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  TextField,
  Box,
} from "@mui/material";
import axios from "axios";
import "./UserMaintenance.css";
import * as XLSX from "xlsx";
import { BASE_API_URL } from "../../utils/constants";
import InputAdornment from "@mui/material/InputAdornment";
import { Pagination } from "antd";

export default function UserMaintenance() {
  const [users, setUsers] = useState([]);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const res = await axios.get(`${BASE_API_URL}/users`);
      setUsers(res.data);
    } catch (err) {
      console.error("Error fetching users", err);
    }
  };

  const filteredUsers = users.filter((user) =>
    user.enterpriseId?.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const paginatedUsers = filteredUsers.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );

  const handleDownload = () => {
    const exportData = filteredUsers.map((user) => ({
      "Enterprise ID": user.enterpriseId,
      Name: user.name,
      Role: user.role,
      Level: user.level,
      Category: user.category,
      Capability: user.capability,
      Industry: user.industry,
      "MU Smart": user.muSmart,
      "Supervisory Org L5": user.supervisoryOrganizationLevel5,
      Owner: user.owner,
      "Business Unit": user.businessUnit,
      Geography: user.geography,
      Status: user.status,
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "User Maintenance");

    XLSX.writeFile(workbook, "User_Maintenance.xlsx");
  };

  return (
    <>
      <div style={{ padding: "20px", marginTop: "1rem" }}>
        <Box
          flex={1}
          display="flex"
          justifyContent="space-between"
          sx={{ marginBottom: "10px" }}
        >
          <TextField
            placeholder="Search by Enterprise ID"
            variant="standard"
            size="small"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/Assets/UserMaintenance/search-icon.png"
                    }
                    alt="search-icon"
                    style={{ width: 20, height: 20, cursor: "pointer" }}
                  />
                </InputAdornment>
              ),
              disableUnderline: true,
            }}
            sx={{
              "& .MuiInputBase-root": {
                border: "1px solid rgb(70, 0, 115)",
                paddingRight: "8px",
                paddingLeft: "8px",
              },
              "& input": {
                padding: "8px 6px",
                fontSize: "14px",
              },
              "& input::placeholder": {
                color: "grey !important",
                opacity: 1,
              },
            }}
          />
          <Button
            variant="contained"
            color="primary"
            className="download-user-btn"
            onClick={handleDownload}
          >
            Download
          </Button>
        </Box>

        <TableContainer sx={{ marginBottom: "1rem", borderRadius: "5px" }}>
          <Table
            size="small"
            sx={{
              borderLeft: "1px solid rgba(224, 224, 224, 1)",
              borderRight: "1px solid rgba(224, 224, 224, 1)",
              minWidth: 1600,
            }}
          >
            <TableHead>
              <TableRow style={{ backgroundColor: "#7500c0" }}>
                <TableCell className="table-headers" sx={{ padding: "15px" }}>
                  Sl#
                </TableCell>
                <TableCell className="table-headers" sx={{ padding: "15px" }}>
                  Enterprise ID
                </TableCell>
                <TableCell className="table-headers" sx={{ padding: "15px" }}>
                  Name
                </TableCell>
                <TableCell className="table-headers" sx={{ padding: "15px" }}>
                  Role
                </TableCell>
                <TableCell className="table-headers" sx={{ padding: "15px" }}>
                  Level
                </TableCell>
                <TableCell className="table-headers" sx={{ padding: "15px" }}>
                  Category
                </TableCell>
                <TableCell className="table-headers" sx={{ padding: "15px" }}>
                  Capability
                </TableCell>
                <TableCell className="table-headers" sx={{ padding: "15px" }}>
                  Industry
                </TableCell>
                <TableCell className="table-headers" sx={{ padding: "15px" }}>
                  MU Smart
                </TableCell>
                <TableCell className="table-headers" sx={{ padding: "15px" }}>
                  Supervisory Org L5
                </TableCell>
                <TableCell className="table-headers" sx={{ padding: "15px" }}>
                  Owner
                </TableCell>
                <TableCell className="table-headers" sx={{ padding: "15px" }}>
                  Business Unit
                </TableCell>
                <TableCell className="table-headers" sx={{ padding: "15px" }}>
                  Geography
                </TableCell>
                <TableCell className="table-headers" sx={{ padding: "15px" }}>
                  Status
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {paginatedUsers.map((user, index) => (
                <TableRow
                  key={user.id}
                  sx={{
                    backgroundColor: index % 2 === 0 ? "#F1F1EF" : "#FCF7FF",
                  }}
                >
                  <TableCell>{index + 1 + page * rowsPerPage}</TableCell>
                  <TableCell>{user.enterpriseId}</TableCell>
                  <TableCell>{user.name}</TableCell>
                  <TableCell>{user.role}</TableCell>
                  <TableCell>{user.level}</TableCell>
                  <TableCell>{user.category}</TableCell>
                  <TableCell>{user.capability}</TableCell>
                  <TableCell>{user.industry}</TableCell>
                  <TableCell>{user.muSmart}</TableCell>
                  <TableCell>{user.supervisoryOrganizationLevel5}</TableCell>
                  <TableCell>{user.owner}</TableCell>
                  <TableCell>{user.businessUnit}</TableCell>
                  <TableCell>{user.geography}</TableCell>
                  <TableCell>{user.status}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <br />
          <Pagination
            align="center"
            className="t-pagination"
            current={page + 1}
            pageSize={rowsPerPage}
            total={filteredUsers.length}
            showSizeChanger
            pageSizeOptions={[10, 20, 50, 75, 100]}
            onShowSizeChange={(current, size) => {
              setPage(0);
              setRowsPerPage(size);
            }}
            onChange={(pageNumber) => {
              setPage(pageNumber - 1);
            }}
          />
        </TableContainer>
      </div>
    </>
  );
}
